import { ChecklistOutlined } from '@mui/icons-material'
import { Button, Typography } from '@mui/material'
import { useBomItemIssueDescription } from 'features/BillOfMaterials/components/useBomItemIssueDescription'
import { useBomItemDetailsDialog } from 'features/BomItemDetailsDialog/useBomItemDetailsDialog'
import { BomItemType } from 'model/Project/BoMItemRow'
import { IssueDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { useAppSelector } from 'store/configureStore'
import { WorkingStepHourlyRateMetadata } from './WorkingStepHourlyRateMetadata'

type Props = {
  issue: IssueDto
}

/**
 * handles project level issue code for working step hourly rates not set
 * @param props
 * @returns
 */
export const WorkingStepHourlyRatesNotSetTodo = (props: Props) => {
  const { getIssueDescription } = useBomItemIssueDescription()

  const projectId = useAppSelector((state) => state.project?.activeProject?.id)

  let meta: WorkingStepHourlyRateMetadata = undefined
  try {
    meta = JSON.parse(props.issue?.metadata)
  } catch (err) {
    console.error(err)
  }

  const openDetailsDialog = useBomItemDetailsDialog()

  const handleClick = () => {
    openDetailsDialog('financials', {
      bomItemPointer: {
        id: projectId,
        type: BomItemType.project,
      },
    })
  }

  return (
    <Button
      component={'li'}
      style={{
        display: 'flex',
        gap: '1em',
      }}
      color="inherit"
      onClick={handleClick}
      startIcon={<ChecklistOutlined />}
    >
      <div>
        <Typography variant="body2">
          {getIssueDescription(props.issue)}
        </Typography>
      </div>
    </Button>
  )
}
